import axios from 'axios';

import config from '../../../../config/config';

import {
  prepareQueryParams,
  QueryParamItem,
} from '../../../../utils/validations/queryParamsHelpers';

const MainUrl = 'api/reports';

export const getSubscriptionFinanceReports = (date: string) => {
  const queryParams: QueryParamItem[] = [
    {
      name: 'month',
      value: date,
    },
  ];

  const params = prepareQueryParams({ queryParams });

  return axios.get(`${MainUrl}/subscriptionFinance${params}`, {
    baseURL: config.reportsApi.baseUrl,
    headers: { accept: 'text/csv' },
  });
};

export const getRetailFinanceReports = (date: string) => {
  const queryParams: QueryParamItem[] = [
    {
      name: 'month',
      value: date,
    },
  ];

  const params = prepareQueryParams({ queryParams });

  return axios.get(`${MainUrl}/retailFinance${params}`, {
    baseURL: config.reportsApi.baseUrl,
    headers: { accept: 'text/csv' },
  });
};
